<template>
  <div>
    <div class="w-full flex flex-row overflow-x-scroll">
      <div v-for='screenshot in sortedScreenshots' :key='screenshot.id' class="flex-none mx-4">
        <a :href='screenshot.url' target='_blank' :download='id' @click='onClickScreenshot'>
          <img class="w-48 h-64 object-contain" :src='screenshot.thumbnailUrl' loading='lazy' />
        </a>
        <p class="text-white text-center text-lg">{{screenshot.timestampString}}</p>
      </div>
    </div>
  </div>
</template>
<script>
import { orderBy } from 'lodash';
export default {
  inject:['api'],
  props:{
    clip:{
      type:Object,
      required:true
    },
    postId:{
      type:String,
      default:''
    }
  },
  methods:{
    onClickScreenshot() {
      this.$ana.track({
        eventCategory:'download',
        eventAction:'png',
        extra:{
          id:this.postId
        }
      });
    }
  },
  computed:{
    sortedScreenshots() {
      return orderBy(this.clip.screenshots || [], (s) => {
        return s.timestamp;
      }).map( (s) => {
        const url = this.api.makeScreenshotUrlEditor(this.postId, s.id);
        const thumbnailUrl = this.api.makeScreenshotUrlEditor(this.postId, s.thumbnail);
        const timestampString = (s.timestamp / 1000).toFixed(2) + 's';
        const screenshot = {
          ...s,
          url,
          thumbnailUrl,
          timestampString
        }
        return screenshot;
      });
    }
  }
}
</script>
